import apiFetch from '../apiFetch'

export default function (idCentro, token) {
  return apiFetch({endPoint: `EmpresaCentro/deleteCentro?idCentro=` + idCentro, method: 'GET', body: null, token: token})
}
